import { currencyMask } from '../../../../../utils/masks/currencyMask.ts'

import type { PreviaSemanalAccountProps, PreviaSemanalWeekProps } from '@services/api/consolidatedEntry/types'

export const buildInitialAccountValues = (
  accounts: PreviaSemanalAccountProps[],
  weeks: PreviaSemanalWeekProps[]
): Record<number, string> => {
  const currentWeekNumber = weeks.find((week) => week.isCurrent)?.weekNumber

  return accounts.reduce<Record<number, string>>((values, account) => {
    const currentWeekValue = account.weeks.find((week) => week.weekNumber === currentWeekNumber)?.value

    values[account.accountId] = currentWeekValue !== undefined ? currencyMask(currentWeekValue) : ''

    return values
  }, {})
}
